import React from 'react'
// import React, { useState } from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';
// import { InputText } from 'primereact/inputtext';
// import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';

function Configuracion() {
    // const [value, setValue] = useState('');
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8 mb-6'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Configuraci&oacute;n de Cuenta</p>
                
                <div className='grid grid-cols-2 lg:grid-cols-10 gap-2'>
                    <div className='col-span-1 font-bold items-center text-base flex'>Empresa</div>
                    <div className='col-span-1 lg:col-span-9 items-center text-base'>
                        Ariel Provisiones S.R.L.
                    </div>
                    <div className='col-span-1 font-bold items-center text-base flex'>RNC/Cedula</div>
                    <div className='col-span-1 lg:col-span-4 items-center text-base'>
                        03102894494
                    </div>
                    <div className='col-span-1 font-bold items-center text-base flex'>Referencia</div>
                    <div className='col-span-1 lg:col-span-4 items-center text-base'>
                        Ariel
                    </div>
                    <div className='col-span-1 font-bold items-center text-base flex'>Modo de Uso</div>
                    <div className='col-span-1 lg:col-span-4 items-center text-base'>
                        A - API WEB
                    </div>
                    <div className='col-span-1 font-bold items-center text-base flex'>Status</div>
                    <div className='col-span-1 lg:col-span-4 items-center text-base'>
                        <Tag className='bg-green-700' value={'Activo'} severity={'success'}></Tag>
                        {/* <Tag className='' value={'Inactivo'} severity={'danger'}></Tag> */}
                        {/* <Tag className='' value={'Suspendido'} severity={'warning'}></Tag> */}
                    </div>
                    <div className='col-span-2 lg:col-span-1 font-bold items-center text-base flex'>Path</div>
                    <div className='col-span-2 lg:col-span-4 items-center text-base'>
                        ariel_ajuvvgnuvwdvbm
                    </div>
                    <div className='col-span-2 lg:col-span-1 font-bold items-center text-base flex'>Servidor</div>
                    <div className='col-span-2 lg:col-span-4 items-center text-base'>
                        ncfelectronicos.racolcomputers.com
                    </div>
                </div>
                
                <div className='mt-10'>
                    <p className='text-base font-bold'>Rutas DGII:</p>
                    <p className='text-base break-words'>
                        <span className='font-bold'>Semilla:&nbsp;</span>
                        <span className='font-bold text-green-700'>https://ncfelectronicos.racolcomputers.com/api/racol_shjkugj4q0pwbu/fe/autenticacion/api/semilla</span>
                    </p>
                    <p className='text-base break-words'>
                        <span className='font-bold'>Validaci&oacute;n:&nbsp;</span>
                        <span className='font-bold text-green-700'>https://ncfelectronicos.racolcomputers.com/api/racol_shjkugj4q0pwbu/fe/autenticacion/api/validacioncertificado</span>
                    </p>
                    <p className='text-base break-words'>
                        <span className='font-bold'>Recepci&oacute;n e-CF:&nbsp;</span>
                        <span className='font-bold text-green-700'>https://ncfelectronicos.racolcomputers.com/api/racol_shjkugj4q0pwbu/fe/recepcion/api/ecf</span>
                    </p>
                    <p className='text-base break-words'>
                        <span className='font-bold'>Aprobaci&oacute;n Comercial:&nbsp;</span>
                        <span className='font-bold text-green-700'>https://ncfelectronicos.racolcomputers.com/api/racol_shjkugj4q0pwbu/fe/aprobacioncomercial/api/ecf</span>
                    </p>
                </div>
                <div className='mt-10'>
                    <p className='text-base font-bold'>Opciones:</p>
                    <div className='flex flex-row'>
                        <Button className='web-boton'>
                            <i className="material-icons-outlined">lock_reset</i>&nbsp;
                            Cambiar Password
                        </Button>
                    </div>
                </div>
            </div>
        </UserContainerComponent>
    )
}

export default Configuracion;